/**
 * 신고이력 검색어 줄이기(2026-10-07) — 이력 검색 서버는 검색어를 200자까지만 받는다(201자부터 400 invalid_query).
 * 인보이스 품명을 통째로 붙인 검색어(예: "MAGNET SYSTEM ASCEND EVO 600 M · HZ, S/N:10784 CONSIST OF …" 420자)는
 * 거절되고, 200자 안이라도 낱말이 많으면 모든 낱말이 맞는 신고가 없어 0건이 된다.
 * 그래서 긴 검색어만 앞머리 품명(첫 쉼표·세미콜론·"CONSIST OF"·" · "·"S/N" 앞)으로 찾는다. 200자 이하는 그대로 둔다.
 */
export const HISTORY_QUERY_MAX = 200;

export function historyQuery(q) {
  const s = String(q || "").trim().replace(/\s+/g, " ");
  if (s.length <= HISTORY_QUERY_MAX) return s;
  const head = s.split(/[,;]|\s+CONSIST(?:ING)?\s+OF\s+|\s+·\s+|\s+S\/N\b|\s+-\s+/i)[0].trim();
  if (head.length >= 3 && head.length <= HISTORY_QUERY_MAX) return head;
  const cut = s.slice(0, HISTORY_QUERY_MAX);
  const sp = cut.lastIndexOf(" ");
  return (sp > 40 ? cut.slice(0, sp) : cut).trim();
}

// 1단계(2026-10-07): 모델·부품번호 정확 일치 — 같은 번호가 전에 신고됐다면 가장 정확한 근거다.
// 번호는 **앞머리 품명에서만** 뽑는다. 부분품 목록에서 뽑으면(예: 케이블 모델 BSMS/2) 본체가 아닌 부분품 이력이 나온다.
// 일련번호(S/N), 단위가 붙은 수치(600MHZ·25L·1140MM), 숫자만인 것, 5자 이하는 번호로 보지 않는다.
const UNIT = /^\d+([.,]\d+)?(MM|CM|M|KM|KG|G|MG|T|TON|L|ML|V|KV|MV|W|KW|MW|VA|KVA|HZ|KHZ|MHZ|GHZ|A|MA|AH|MAH|PCS|PC|EA|SET|SETS|IN|INCH|FT|LB|LBS|OZ|GB|TB|MB|RPM|BAR|PSI|DB)$/i;

export function historyIdentifier(q) {
  const s = String(q || "").trim().replace(/\s+/g, " ");
  const head = s.split(/[,;]|\s+CONSIST(?:ING)?\s+OF\s+|\s+·\s+|\s+-\s+/i)[0].trim();
  const tokens = head.split(/[\s()[\]]+/).map((t) => t.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, ""));
  const ids = tokens.filter((t) => t.length >= 6 && /[A-Za-z]/.test(t) && /\d/.test(t) && !UNIT.test(t) && !/^S\/?N/i.test(t));
  if (!ids.length) return "";
  const best = ids.sort((a, b) => b.length - a.length)[0];
  return best.toUpperCase() === s.toUpperCase() ? "" : best;   // 검색어가 번호 하나뿐이면 키워드 검색과 같다
}
